import { createLoadAdapter } from '../../ngrx-helpers/adapters/load/adapter';
import { ProjectSummary } from '../project/models/project-summary.model';
import { LoadState } from '../../ngrx-helpers/adapters/load/reducer';

export const apiKeyFormProjectsAdapter = createLoadAdapter<ProjectSummary>({
  stateKey: 'apiKeyForm',
  type: 'Api Key Form Projects',
});

export interface ApiKeyFormProjectsState extends LoadState<ProjectSummary> {}
